const REVIEWS_URL =
  'https://www.google.com/search?sca_esv=bb0c18cfc693bbae&cs=1&si=AMgyJEtREmoPL4P1I5IDCfuA8gybfVI2d5Uj7QMwYCZHKDZ-E8uuilbmduL26E-TuTr7YL1oUXO0MT0_Ea7i_T2m_CvQHxgvQIzRfQdBe6GOx_MLtFrHV0ffk2r0YzGIx2Jwo60n0FrH&q=The+Bake+Nook+Reviews&sa=X&ved=2ahUKEwjj0O3T9uqRAxVmaCoJHbZ9AlMQ0bkNegQIHxAE&biw=1299&bih=819&dpr=2#'

const stats = [
  { number: '3k+', label: 'cakes baked' },
  { number: '4.9', label: 'Google rating', href: REVIEWS_URL },
  { number: '100%', label: 'fresh cream' },
]

function StatsSection() {
  return (
    <section className="bg-white">
      <div className="container mx-auto px-4 py-6 md:py-10">
        <div className="grid grid-cols-3 gap-3 max-w-3xl mx-auto md:text-center">
          {stats.map((s) => {
            const body = (
              <>
                <div className="font-heading text-[28px] md:text-4xl lg:text-5xl font-bold text-charcoal leading-none">{s.number}</div>
                <div className="text-xs md:text-sm text-gray-500 mt-1">{s.label}</div>
              </>
            )
            return s.href ? (
              <a key={s.label} href={s.href} target="_blank" rel="noopener noreferrer" className="block hover:opacity-80 transition-opacity">
                {body}
              </a>
            ) : (
              <div key={s.label}>{body}</div>
            )
          })}
        </div>
      </div>
    </section>
  )
}

export default StatsSection
